import { styled } from 'styled-components';

import { Button } from '#/components/Button/Button';
import { Portal } from '#/components/Portal/Portal';
import { Body } from '#/components/Text/Body';
import { H2 } from '#/components/Text/H2';
import { useI18n } from '#/i18n/hooks/useI18n';
import { Modal } from '#/modals/Modal';

type Props = {
  onConfirm: () => void;
  onClose: () => void;
};

const ModalWrapper = styled.div`
  margin-top: 8px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 8px;
`;

export function SVGConfirmationModal({ onClose, onConfirm }: Props) {
  const { i18n } = useI18n();

  return (
    <Portal>
      <Modal wide onClose={onClose} qaId="svg-upload-warning">
        <ModalWrapper>
          <H2>{i18n('Warning!')}</H2>
          <Body>
            {i18n(
              'SVG files downloaded from the Internet may contain malicious code that makes Idealist vulnerable to attacks. Please upload ONLY files that have been exported directly from a design tool or been vetted by design.',
            )}
          </Body>
          <ButtonContainer>
            <Button type="button" variant="danger" onClick={onConfirm}>
              {i18n('Continue')}
            </Button>
            <Button type="button" variant="primary" onClick={onClose}>
              {i18n('Nevermind, Go Back')}
            </Button>
          </ButtonContainer>
        </ModalWrapper>
      </Modal>
    </Portal>
  );
}
